// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2oxZz","label":"Radio_label__19wF4","checkMark":"Radio_checkMark__2ybFg","disabled":"Radio_disabled__1Qdhu"};